export default (value) => {
  const filteredValue = value > 0 ? value : 0;
  const totalCents = Math.round(filteredValue * 100);
  const reais = String(Math.floor(totalCents / 100));
  const cents = String(totalCents % 100).padStart(2, "0");

  const invertedReais = invert(reais);
  const spacedInvertedReais = invertedReais.match(/.{1,3}/g).join(".");
  const spacedReais = invert(spacedInvertedReais);

  return `R$ ${spacedReais},${cents}`;
};

const invert = (s) => s.split("").reverse().join("");
